import client from './client';

/**
 * Get the passage for a specific round
 */
export const getPassage = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/passage`);
  return response.data;
};

/**
 * Update/save passage draft (GM only)
 */
export const updatePassage = async (gameId, roundId, data) => {
  const response = await client.put(`/api/games/${gameId}/rounds/${roundId}/passage`, data);
  return response.data;
};

/**
 * Publish the passage (GM only)
 */
export const publishPassage = async (gameId, roundId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/passage/publish`);
  return response.data;
};

/**
 * Get all published passages for a game (the story so far)
 */
export const getAllPassages = async (gameId, sceneId = null) => {
  const params = sceneId ? { sceneId } : {};
  const response = await client.get(`/api/games/${gameId}/passages`, { params });
  return response.data;
};

/**
 * Get a specific passage by number
 */
export const getPassageByNumber = async (gameId, number) => {
  const response = await client.get(`/api/games/${gameId}/passages/${number}`);
  return response.data;
};
